const token = (state) => {
  return window.$cookies.get('_session')
}

export default {
  token
}
